import React from 'react'
import PropTypes from 'prop-types'
import { colors } from '@lmc/common/constants'
import { darken, lighten } from '../../../LEGACY/colorUtils'
import { css, StyleSheet } from 'aphrodite/no-important'
import { GlyphButton } from '../../../LEGACY/elemental'
import { isBrowser, isTablet } from 'react-device-detect'

const MedicationItem = ({ medication, onDelete, onEdit }) => {
  if (!medication) return null

  const {
    name,
    doseageInstructions,
    additionalInformation,
    timing,
    controlledDrug,
  } = medication

  return (
    <div className="lmc-card">
      <div style={styles.responsiveContainer}>
        <div style={styles.titleContainer}>
          <span style={styles.title}>{name}</span>
          {controlledDrug && isDesktop && (
            <div style={styles.badge}>Controlled Drug</div>
          )}
        </div>
        <div
          style={{
            ...styles.buttonsContainer,
            justifyContent: isDesktop
              ? null
              : controlledDrug
              ? 'space-between'
              : 'flex-end',
          }}
        >
          {controlledDrug && !isDesktop && (
            <div style={styles.badge}>Controlled Drug</div>
          )}
          <div>
            <GlyphButton
              className={css(buttonClasses.edit)}
              glyph="pencil"
              onClick={() => onEdit(medication)}
              position={isDesktop ? 'left' : 'default'}
            >
              {isDesktop ? 'Edit' : ''}
            </GlyphButton>
            <GlyphButton
              className={css(buttonClasses.delete)}
              glyph="trashcan"
              onClick={() => onDelete(medication.id)}
              position={isDesktop ? 'left' : 'default'}
            >
              {isDesktop ? 'Delete' : ''}
            </GlyphButton>
          </div>
        </div>
      </div>
      <div style={styles.divider} />
      <div style={styles.responsiveContainer}>
        <div style={styles.infoContainer}>
          <span style={styles.infoLabel}>Dosage Instructions</span>
          <div style={styles.infoValue}>{doseageInstructions}</div>
        </div>
        <div style={styles.infoContainer}>
          <span style={styles.infoLabel}>Additional Information</span>
          {additionalInformation ? (
            <div style={styles.infoValue}>{additionalInformation}</div>
          ) : (
            <div
              style={{
                ...styles.infoValue,
                ...styles.noInformation,
              }}
            >
              No information entered
            </div>
          )}
        </div>
        <div
          style={{ ...styles.infoContainer, width: isDesktop ? '30%' : null }}
        >
          <span style={styles.infoLabel}>Timing</span>
          <div style={styles.infoValue}>{timing ? timing.join(', ') : ''}</div>
        </div>
      </div>
    </div>
  )
}

const isDesktop = isBrowser || isTablet

const styles = {
  badge: {
    alignSelf: 'center',
    background: lighten(colors.red, 80),
    color: darken(colors.red, 20),
    flexShrink: 0,
    fontSize: 12,
    fontWeight: 'bold',
    marginRight: 8,
    padding: '3px 12px 2px',
    borderRadius: 15,
  },
  buttonsContainer: {
    display: 'flex',
    flexShrink: 0,
    justifyContent: isDesktop ? null : 'space-between',
    marginTop: isDesktop ? null : 9,
  },
  divider: {
    background: colors.grey,
    height: 1,
    marginTop: 9,
    width: '100%',
  },
  infoContainer: {
    paddingTop: 12,
    marginRight: 24,
    width: isDesktop ? '35%' : null,
  },
  infoLabel: {
    fontWeight: 'bold',
  },
  infoValue: {
    paddingTop: 9,
  },
  noInformation: {
    color: colors.black,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginRight: 8,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: isDesktop ? 'nowrap' : null,
  },
  titleContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: isDesktop ? null : 'space-between',
    minWidth: 0,
  },
  responsiveContainer: {
    display: isDesktop ? 'flex' : 'block',
    justifyContent: isDesktop ? 'space-between' : null,
  },
}

const buttonClasses = StyleSheet.create({
  delete: {
    background: 'Transparent',
    color: colors.darkgrey,
    fontSize: 12,
    transition: 'all .2s ease',
    textShadow: 'none',
    ':hover': {
      background: colors.red,
      color: 'white',
      textShadow: 'none',
    },
  },
  edit: {
    background: 'Transparent',
    color: colors.darkgrey,
    fontSize: 12,
    transition: 'all .2s ease',
    textShadow: 'none',
    ':hover': {
      background: colors.orange,
      color: 'white',
      textShadow: 'none',
    },
  },
})

MedicationItem.propTypes = {
  medication: PropTypes.shape({
    name: PropTypes.string.isRequired,
    doseageInstructions: PropTypes.string.isRequired,
    additionalInformation: PropTypes.string,
    timing: PropTypes.array.isRequired,
    controlledDrug: PropTypes.bool,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
}

export default MedicationItem
